import React from "react";
import { useNavigate } from "react-router";
import AddIcon from "../../assets/icons/addIcon";
import { AdminButton } from "./versionHistoryBtn";

const DeleteBtn = ({ deleteFn}) => {
  const navigate = useNavigate();
  return (
    <AdminButton
      background="#FF6F5B"
      color="white"
      width="100px"
      onClick={() => deleteFn()}
    >
      <span className="m-2">DELETE</span>
    </AdminButton>
  );
};

export default DeleteBtn;
